import { defineComponent } from 'vue';
import { CircleHelp } from 'lucide-vue-next';
export default defineComponent({
    name: 'Help',
    components: { CircleHelp },
});
